import React, { FC } from 'react'
import './index.scss'

export const Button: FC<any> = ({ className, ...props }: any) => (
    <button className={ `btn btn-15 c-btn ${className}` } { ...props }>
        { props.children }
    </button>
)
